import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  receiveCategories,
  receiveDocumentTypes,
  setQuery,
  searchFiles,
  toggleSelect,
  setCategory,
  setDocumentType,
  setPage,
} from '../Actions/Library.action';

const LibrarySearch = () => {
  const timer = useRef(null);
  const dispatch = useDispatch();
  const {
    categories,
    documentTypes,
    category,
    documentType,
    fileTemplateType,
    query,
    pageNumber,
  } = useSelector((state) => state.library);
  const [term, setTerm] = useState('');
  useEffect(() => {
    const categoriesList = parseList('categories');
    dispatch(receiveCategories(categoriesList));
    const documentTypesList = parseList('documentTypes');
    dispatch(receiveDocumentTypes(documentTypesList));
  }, []);
  const parseList = (name) => {
    const attr = document.getElementById('librarySearch').getAttribute(name);
    return JSON.parse(attr);
  };
  const search = (e) => {
    const val = e.target.value;
    dispatch(setPage(1));
    setTerm(val);
  };
  useEffect(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      dispatch(setQuery(term));
    }, 700);
  }, [term]);
  useEffect(() => {
    dispatch(
      searchFiles(fileTemplateType, query, category, documentType, pageNumber)
    );
    dispatch(toggleSelect([]));
  }, [category, documentType, fileTemplateType, query, pageNumber]);
  const selectCategory = (category) => {
    const val = category.toLowerCase() === 'all' ? '' : category;
    dispatch(setPage(1));
    dispatch(setCategory(val));
  };
  const changeDocType = (e) => {
    const val = e.target.value;
    dispatch(setPage(1));
    dispatch(setDocumentType(val));
  };
  return (
    <Fragment>
      <div className="row">
        <div className="columns small-12 large-8">
          <label className="library__search--label">Search</label>
          <div className="library__search--box">
            <input
              className="form__input"
              type="text"
              value={term}
              onChange={search}
              placeholder="Search"
            />
          </div>
        </div>
        <div className="columns small-12 large-4">
          <label className="library__search--label">Content category</label>
          <div className="library__select">
            <select
              className="form__input"
              value={documentType}
              onChange={changeDocType}
            >
              {documentTypes.map((docType) => (
                <option key={docType.documentType} value={docType.documentType}>
                  {docType.documentTypeText}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        {categories.map((item, index) => (
          <div key={index} className="columns shrink">
            <div
              className={`library__category ${
                item.category === category ||
                (item.category.toLowerCase() === 'all' && category === '')
                  ? 'active'
                  : ''
              }`}
              onClick={() => selectCategory(item.category)}
            >
              {item.categoryText}
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default LibrarySearch;
